module.exports = __webpack_public_path__ + "d708cb7ac1b296ec3cb5bb4b8554b5c4.svg";